module.exports = __webpack_public_path__ + "img/b2a.4997099f.jpg";